/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.ts to modify the generation of this file.
const config = {};
config.sitecoreApiKey = process.env.VUE_APP_SITECORE_API_KEY || "{15303104-694B-4C41-B5A6-2B283B98C41C}";
config.sitecoreApiHost = process.env.VUE_APP_SITECORE_API_HOST || "https://dev.zdn.local/";
config.jssAppName = process.env.VUE_APP_JSS_APP_NAME || "salesfunnel";
config.defaultLanguage = process.env.VUE_APP_DEFAULT_LANGUAGE || "nl-NL";
config.graphQLEndpointPath = process.env.VUE_APP_GRAPH_QL_ENDPOINT_PATH || "/api/salesfunnel";
export default config;